import { useEffect } from "react";
import styles from "../../../styles/Login.module.css";
import { formatBRL, formatCPForCNPJInput, formatDataInput, formatNumeroCartao, formatCVV, buscaCep, formatCepInput } from "../../utils/Utils";
import CustomInput from "../CustomInput";

export default function Step4({ values, handleChange, handleBlur, errors, touched, submitting, planoSelecionado, setFieldValue }) {
    
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 10);
    }, []);

    return (
        <div style={{ flex: 1 }}>
            <div className={styles.boxPlanoEscolhido}>
                <div className={styles.headerBoxPlanoEscolhido}>
                    <p>Plano escolhido</p>

                    <small>{planoSelecionado?.label}</small>
                </div>

                <div className={styles.boxValor}>
                    <p>{formatBRL(planoSelecionado?.valor)}</p>

                    <span>/{planoSelecionado?.periodoMin}</span>
                </div>
            </div>

            <div className={`${styles.formLogin}`}>
                <CustomInput placeholder="Nome do titular" label="Nome do titular" name="nome_titular_cartao" value={values.nome_titular_cartao} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />

                <CustomInput placeholder="CPF/CNPJ do titular" label="CPF/CNPJ do titular" name="documento_titular_cartao" value={values.documento_titular_cartao} onChange={(e) => handleChange(formatCPForCNPJInput(e))} onInput={(e) => handleChange(formatCPForCNPJInput(e))} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} maxLength={18} required inputMode="numeric" />

                <CustomInput placeholder="Cartão de crédito" label="Cartão de crédito" name="numero_cartao" value={values.numero_cartao} onChange={(e) => handleChange(formatNumeroCartao(e))} onInput={(e) => handleChange(formatNumeroCartao(e))} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} maxLength={19} required inputMode="numeric" />

                <div className={styles.rowInputs}>
                    <CustomInput placeholder="Data de vencimento" label="Data de vencimento" name="data_vencimento_cartao" value={values.data_vencimento_cartao} onChange={(e) => handleChange(formatDataInput(e))} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} maxLength={5} tipoInputRight="data_cartao" required inputMode="numeric" />

                    <CustomInput placeholder="CVV" label="CVV" name="cvv" value={values.cvv} onChange={(e) => handleChange(formatCVV(e))} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} maxLength={4} tipoInputRight="cvv" required inputMode="numeric" />
                </div>

                <CustomInput placeholder="CEP" label="CEP" name="cep" value={values.cep} onBlur={(e) => handleBlur(buscaCep(e, setFieldValue, "logradouro", "bairro", "cidade", "estado"))} onChange={(e) => handleChange(formatCepInput(e))} errors={errors} touched={touched} disabled={submitting} maxLength={9} required inputMode="numeric" />

                <div className={styles.rowInputs}>
                    <CustomInput placeholder="Logradouro" label="Logradouro" name="logradouro" value={values.logradouro} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />

                    <CustomInput placeholder="Número" label="Número" name="numero" value={values.numero} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />
                </div>

                <CustomInput placeholder="Bairro" label="Bairro" name="bairro" value={values.bairro} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />

                <div className={styles.rowInputs}>
                    <CustomInput placeholder="Cidade" label="Cidade" name="cidade" value={values.cidade} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />

                    <CustomInput placeholder="Estado" label="Estado" name="estado" value={values.estado} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} required />
                </div>
            </div>
        </div>
    );
}
